// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"6e522311","195":"eed6b401","402":"af280b84","517":"06811b47","522":"ed604843","561":"8e5b5ce9","601":"d7b276df","604":"bf3acf5b","619":"d077574a","828":"c394d579","870":"1f923bf0","877":"adb12d5d","887":"3b616a09","918":"2af9323d","964":"5dc65b8d"}[chunkId] + ".chunk.js";
};